import UsagiSplitText from './class/usagi-split-text.js';

//
window.CHAR_DELAY = 0.025;

//
window.styleText = {

	ready : false,
	local : null,
	array : [],

	onInit( elem ){

		this.local = !elem ? document : elem;
		this.elem = this.local.querySelectorAll('.js-split');
		this.elem.forEach( (el,i) =>{
			const type = el.dataset.splitType;
			const lang = el.dataset.splitLang;
			const timing = el.dataset.timing ? el.dataset.timing : 'inview';
			const enable = !( el.dataset.disable === "any" && DETECT.device.any );
			const charDelay = el.dataset.charDelay ? Number( el.dataset.charDelay ) : 0.002;
			const wordDelay = el.dataset.wordDelay ? Number( el.dataset.wordDelay ) : 0.025;
			if( enable ){
				const split = new UsagiSplitText({
					el : el,
					type : type,
					delay : 0,
					charDelay : charDelay,
					wordDelay : wordDelay,
					lineDelay : 0.1,
					lang : lang,
					inview : true,
					css : true,
					timing : timing,
					center : false
				});
				this.array.push({
					split : split
				});				
			}

		});
		this.ready = true;

	},

	onResize(){
		for (let i = 0; i < this.array.length; i++) {
			const v = this.array[i];
			v.split.onResize();
		}
	},

	onDestroy(){
		this.ready = false;
		for (let i = 0; i < this.array.length; i++) {
			const v = this.array[i];
			v.split.onDestroy();
		}
		this.array = [];
	}

}
















